module.exports = __webpack_public_path__ + "static/media/events-header.1d2fa738.jpg";